<template>
    <div class="wrapper">
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper">
            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h1 class="m-0 title">Edit Profile</h1>
                        </div><!-- /.col -->
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/dash">Home</router-link></li>
                            <li class="breadcrumb-item active">Edit Profile</li>
                            </ol>
                        </div><!-- /.col -->
                    </div><!-- /.row -->
                </div>
            </section>
            <section class="content edit_profile">
                <div class="container-fluid">
                    <div class="alert alert-warning" v-if="dataakun.profile_verified_at !== null && !loading" role="alert">
                    Your Profile is already verified!
                    </div>
                    <form id="edit-profile" @submit.prevent="editProfile()">
                        <div class="row">
                            <div class="col-lg-6">
                                
                                <input type="hidden" v-model="datainvestor.id" class="form-control" id="id" name="id">
                                <div class="form-row">
                                    <div class="form-group col-sm-6">
                                        <label for="first_name">First Name</label>
                                        <input type="text" :disabled="dataakun.profile_verified_at !== null" v-model="datainvestor.first_name" v-validate="'required'" class="capitalize form-control" id="first_name" name="first_name">
                                        <div v-if="submitted && errors.has('first_name')" class="text-danger">
                                            {{errors.first('first_name')?'First Name is required':''}}
                                        </div>
                                        <!-- <div v-else-if="submitted && message.first_name !== null" class="text-danger">
                                            {{message.first_name[0]}}
                                        </div> -->
                                    </div>
                                    <div class="form-group col-sm-6">
                                        <label for="last_name">Last Name</label>
                                        <input type="text" :disabled="dataakun.profile_verified_at !== null" v-model="datainvestor.last_name" v-validate="'required'" class="capitalize form-control" id="last_name" name="last_name">
                                        <div v-if="submitted && errors.has('last_name')" class="text-danger">
                                            {{errors.first('last_name')?'Last Name is required':''}}
                                        </div>
                                        <!-- <div v-if="message.last_name" class="text-danger">
                                            {{message.last_name[0]}}
                                        </div> -->
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="phone">Phone</label>
                                    <vue-tel-input v-bind="bindProps" :disabled="dataakun.profile_verified_at !== null" v-model="datainvestor.phone" :autoDefaultCountry="false" @input="validateFirstLetter" @validate="validatePhone" v-on:country-changed="countryChanged"></vue-tel-input>
                                    <!-- <vue-tel-input v-model="datainvestor.phone"
                                    :autoDefaultCountry="true"
                                    @validate="validatePhone"
                                    @country-changed="countryChanged"
                                    @input="validateFirstLetter"></vue-tel-input> -->
                                    <!-- <VuePhoneNumberInput v-model="datainvestor.phone" default-country-code="ID"/> -->
                                    <!-- <input type="tel" maxlength="15" v-model="datainvestor.phone" class="form-control" id="phone" name="phone"> -->
                                    <div v-if="message.phone" class="text-danger">
                                        {{message.phone[0]}}
                                    </div>
                                    <div v-if="submitted && errors.has('phone')" class="text-danger">
                                        {{errors.first('phone')?'Phone is required':''}}
                                    </div>
                                    <div v-if="submitted && datainvestor.phone.length<=6" class="text-danger">
                                        Phone is required
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="dob">Date of Birth</label>
                                    <input type="date" :disabled="dataakun.profile_verified_at !== null" v-model="datainvestor.dob" v-validate="'required'" class="form-control" id="dob" name="dob" placeholder="yyyy-mm-dd" pattern="(?:19|20)\[0-9\]{2}-(?:(?:0\[1-9\]|1\[0-2\])-(?:0\[1-9\]|1\[0-9\]|2\[0-9\])|(?:(?!02)(?:0\[1-9\]|1\[0-2\])-(?:30))|(?:(?:0\[13578\]|1\[02\])-31))">
                                    <div v-if="message.dob" class="text-danger">
                                        {{message.dob[0]}}
                                    </div>
                                    <div v-if="submitted && errors.has('dob')" class="text-danger">
                                        {{errors.first('dob')?'Date is required':''}}
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-sm-6">
                                        <label for="country">Country</label>
                                        <input type="search" :disabled="dataakun.profile_verified_at !== null" placeholder="Search country" list="country" v-model="datainvestor.country" class="form-control" />
                                        <datalist id="country">
                                        <!-- <select name="country" id="country" v-model="datainvestor.country" class="custom-select"> -->
                                            <!-- <option value="" selected disabled>Select Country</option> -->
                                            <option :value="list.country" v-for="list in listCountry" :key="list.id">
                                                {{list.country}}
                                            </option>
                                        </datalist>
                                        <!-- <input type="text" v-model="datainvestor.country" class="form-control" id="country" name="country"> -->
                                        <div v-if="message.country" class="text-danger">
                                            {{message.country[0]}}
                                        </div>
                                    </div>
                                    <div class="form-group col-sm-6">
                                        <label for="city">City</label>
                                        <input type="text" :disabled="dataakun.profile_verified_at !== null" v-model="datainvestor.city" class="form-control" id="city" name="city">
                                        <div v-if="message.city" class="text-danger">
                                            {{message.city[0]}}
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="address">Address</label>
                                    <textarea v-model="datainvestor.address" :disabled="dataakun.profile_verified_at !== null" class="form-control" id="address" rows="5"></textarea>
                                    <div v-if="message.address" class="text-danger">
                                        {{message.address[0]}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label for="identity_type">Identity type</label>
                                    <select v-model="datainvestor.identity_type" :disabled="dataakun.profile_verified_at !== null" class="form-control" id="identity_type">
                                        <option selected disabled>Choose..</option>
                                        <option value="ID_CARD">E-KTP</option>
                                        <option value="PASSPORT">PASSPORT</option>
                                        <option value="DRIVING_LICENCE">DRIVING LICENSE</option>
                                    </select>
                                    <div v-if="message.identity_type" class="text-danger">
                                        {{message.identity_type[0]}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="identity_number">Identity Number</label>
                                    <input type="text" :disabled="dataakun.profile_verified_at !== null" v-if="datainvestor.identity_type === 'PASSPORT'" v-model="datainvestor.identity_number" v-validate="'required'" class="form-control" id="identity_number" name="identity_number">
                                    <input type="tel" :disabled="dataakun.profile_verified_at !== null" v-on:keypress="NumbersOnly" v-else v-model="datainvestor.identity_number" v-validate="'required|numeric'" class="form-control" id="identity_number" name="identity_number">
                                    <div v-if="message.identity_number" class="text-danger">
                                        {{message.identity_number[0]}}
                                    </div>
                                    <div v-if="submitted && datainvestor.identity_number == ''" class="text-danger">
                                        Identity Number is required
                                    </div>
                                    <!-- <div v-if="submitted && errors.has('identity_number')" class="text-danger">
                                        {{errors.first('identity_number')}}
                                    </div> -->
                                </div>
                                
                                <div class="form-row">
                                    <div class="form-group col-sm-6">
                                        <label for="identity_number">Identity Photo <span class="text-danger font-italic">*</span> </label><br>
                                        <b-tooltip target="tooltip-target-1" triggers="hover">
                                            Uploaded files have a maximum size of 2 MB. Make sure the identity in the comparison file matches the previously uploaded file. Example : ID Card, Passport or Driving License
                                        </b-tooltip>
                                        <div class="custom-file photo_upload" id="tooltip-target-1">
                                            <label for="identity_file" class="custom-file-upload" :style="{'opacity: 0.3;':dataakun.profile_verified_at !== null}">
                                                Upload Photo
                                            </label>
                                            <!-- <input type="file" ref="fileInput" @change="previewImage" accept="all" class="" name="identity_file" id="identity_file"> -->
                                            <input type="file" :disabled="dataakun.profile_verified_at !== null" @change="onFileChange" accept="image/*" class="" name="identity_file" id="identity_file">
                                            <input type="hidden" :disabled="dataakun.profile_verified_at !== null" v-model="datainvestor.identity_file" class="form-control" readonly>
                                            <!-- <label class="custom-file-label" for="customFile">Choose file</label> -->
                                        </div>
                                        <template v-if="preview">
                                            <img :src="preview" class="img_identity" />
                                            <!-- <p class="mb-0 image_name">{{ image.name }}</p> -->
                                        </template>
                                        <template v-else>
                                            <img :src="dataakun.identity_file" class="img_identity2" />
                                            <!-- <p class="mb-0 image_name">{{ image.name }}</p> -->
                                        </template>
                                        <!-- <small class="text-muted font-weight-normal font-italic">Uploaded files have a maximum size of 2 MB. Make sure the identity in the comparison file matches the previously uploaded file. Example : ID Card, Passport or Driving License</small> -->
                                        
                                        <div v-if="message.identity_file" class="text-danger">
                                            {{message.identity_file[0]}}
                                        </div>
                                        <div v-if="submitted && imageName == '' && dataakun.identity_file == null" class="text-danger">
                                            Identity Photo is required
                                        </div>
                                        <div v-if="error.identity_file !== ''" class="text-danger">
                                            {{error.identity_file}}
                                        </div>
                                    </div>
                                    <div class="form-group col-sm-6">
                                        <b-tooltip target="tooltip-target-2" triggers="hover">
                                            Uploaded files have a maximum size of 2 MB. Make sure the identity in the comparison file matches the previously uploaded file. Example : Bank Statement or Utility Bill
                                        </b-tooltip>
                                        <label for="comparison_file">Comparison File <span class="text-danger font-italic">*</span> </label>
                                        <div class="custom-file photo_upload" id="tooltip-target-2">
                                            <label for="comparison_file" class="custom-file-upload" :style="{'opacity: 0.3;':dataakun.profile_verified_at !== null}">
                                                Upload Photo
                                            </label>
                                            <!-- <input type="file" ref="fileInput" @change="previewImage" accept="all" class="" name="identity_file" id="identity_file"> -->
                                            <input type="file" :disabled="dataakun.profile_verified_at !== null" @change="onFileCompareChange" accept="image/*" class="" name="comparison_file" id="comparison_file">
                                            <input type="hidden" :disabled="dataakun.profile_verified_at !== null" v-model="datainvestor.comparison_file" class="form-control" readonly>
                                            <!-- <label class="custom-file-label" for="customFile">Choose file</label> -->
                                        </div>
                                        <template v-if="viewCompare">
                                            <img :src="viewCompare" class="img_identity3" />
                                            <!-- <p class="mb-0 image_name">{{ image.name }}</p> -->
                                        </template>
                                        <template v-else>
                                            <img :src="dataakun.comparison_file" class="img_identity3" />
                                            <!-- <p class="mb-0 image_name">{{ image.name }}</p> -->
                                        </template>
                                        <div v-if="message.comparison_file" class="text-danger">
                                            {{message.comparison_file[0]}}
                                        </div>
                                        <div v-if="submitted && compareImage == '' && dataakun.comparison_file == null" class="text-danger">
                                            Comparison File is required
                                        </div>
                                        <div v-if="error.comparison_file !== ''" class="text-danger">
                                            {{error.comparison_file}}
                                        </div>
                                    </div>
                                    <div class="form-group col-sm-6">
                                        <b-tooltip target="tooltip-target-3" triggers="hover">
                                            Uploaded files have a maximum size of 2 MB. Make sure the identity in the comparison file matches the previously uploaded file.
                                        </b-tooltip>
                                        <label for="identity_number">Selfie Image with Identity Card<span class="text-danger font-italic">*</span></label>
                                        <div class="custom-file photo_upload" id="tooltip-target-3">
                                            <label for="selfie_image" class="custom-file-upload" :style="{'opacity: 0.3;':dataakun.profile_verified_at !== null}">
                                                Upload Photo
                                            </label>
                                            <input type="file" :disabled="dataakun.profile_verified_at !== null" @change="onFileSelfieChange" accept="image/*" class="" name="selfie_image" id="selfie_image">
                                            <input type="hidden" :disabled="dataakun.profile_verified_at !== null" v-model="datainvestor.selfie_image" class="form-control" readonly>
                                            <!-- <label class="custom-file-label" for="customFile">Choose file</label> -->
                                        </div>
                                        <template v-if="viewSelfie">
                                            <img :src="viewSelfie" class="img_identity2" />
                                            <!-- <p class="mb-0 image_name">{{ image.name }}</p> -->
                                        </template>
                                        <template v-else>
                                            <img :src="dataakun.selfie_image" class="img_identity2" />
                                            <!-- <p class="mb-0 image_name">{{ image.name }}</p> -->
                                        </template>
                                        <div v-if="message.selfie_image" class="text-danger">
                                            {{message.selfie_image[0]}}
                                        </div>
                                        <div v-if="error.selfie_image !== ''" class="text-danger">
                                            {{error.selfie_image}}
                                        </div>
                                        <div v-if="submitted && selfieImage == '' && dataakun.selfie_image == null" class="text-danger">
                                            Selfie Image is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3 mb-5">
                            <div class="col-sm-2 c-btn">
                                <router-link to="/profile" class="btn btn_outline_red btn-block mb-3">Cancel</router-link>
                            </div>
                            <div class="col-sm-4 up-btn">
                                <button type="submit" class="btn btn_red btn-block mb-3" :disabled="loading || dataakun.profile_verified_at !== null">
                                    <span v-show="loading" class="spinner-border spinner-border-sm mr-2"></span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 31.5 31.5">
                                        <g id="save_icon" transform="translate(-223.85 -684)">
                                            <path id="Icon_awesome-save" data-name="Icon awesome-save" d="M30.511,9.136l-5.9-5.9a3.375,3.375,0,0,0-2.386-.989H3.375A3.375,3.375,0,0,0,0,5.625v24.75A3.375,3.375,0,0,0,3.375,33.75h24.75A3.375,3.375,0,0,0,31.5,30.375V11.523a3.375,3.375,0,0,0-.989-2.386Z" transform="translate(223.85 681.75)" fill="#fff" opacity="0.5"/>
                                            <path id="Union_5" data-name="Union 5" d="M-2894,18a5,5,0,0,1,5-5,5,5,0,0,1,5,5,5,5,0,0,1-5,5A5,5,0,0,1-2894,18Zm-6-9a1,1,0,0,1-1-1V1a1,1,0,0,1,1-1h17a1,1,0,0,1,1,1V8a1,1,0,0,1-1,1Z" transform="translate(3129 688)" fill="#fff"/>
                                        </g>
                                    </svg>
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import axios from 'axios'
import jwt_decode from "jwt-decode"

// import VuePhoneNumberInput from 'vue-phone-number-input';
// import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import country from '../country.json'

export default {
    name: "EditProfileDash",
    components: {
        DashHeader,
        // DashFooter,
        Sidebar,
        // VuePhoneNumberInput
    },
    data(){
		return{
            phoneFirstTimeLoad: 0,
            phoneValid: true,
			dataakun: [],
			akunemail: '',
			message: '',
            validPhone: false,
			sukses: '',
            preview: null,
            viewSelfie: null,
            viewCompare: null,
            image: null,
            imageSelfie: null,
            imageCompare: null,
            submitted: false,
			loading: false,
			imageName: '',
			nameFile: '',
			selfieImage: '',
            compareImage: '',
            listCountry: country,
            country: null,
            bindProps: {
                mode: "international",
                placeholder: "Enter a phone number",
                required: false,
                enabledCountryCode: true,
                enabledFlags: true,
                autocomplete: "off",
                name: "telephone",
				defaultCountry: 62,
                maxLen: 25,
				autoFormat: true,
				showDialCode: true,
                validCharactersOnly: true,
                inputOptions: {
					showDialCode: true,
					maxlength: 17,
                    type: 'tel'
                },
				dropdownOptions: {
					showSearchBox: true,
					showFlags: true,
					width: '400px',
					showDialCodeInList: true,
				}
            },
			datainvestor:{
				id:"",
				first_name:null,
				last_name:null,
				// name:null,
				// username:null,
				// email:null,
				phone:null,
				identity_file:null,
				selfie_image:null,
				comparison_file:null,
				identity_number: "",
				identity_type: "",
				dob: "",
				city: null,
				country: null,
				address: null,
			},
            error: {
				identity_file: '',
				comparison_file: '',
				selfie_image: ''
			}
		}
	},
    async mounted() {
		// if(!this.currentUser) {
		// 	this.$router.push('/login');
		// }
		
		var token = localStorage.getItem('access_token')
		var access_token = jwt_decode(token)
		const user_id = access_token.user_id
		if(!localStorage.getItem('user_id')){
			localStorage.setItem('user_id', user_id)
		}

		this.getProfile()
	},
	methods: {
        // maxVal(){

        // },
        async getProfile(){
            this.loading = true
            var token = localStorage.getItem('access_token')
            await axios.get(`investor/${localStorage.user_id}/`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
            .then(result => {
                // console.log('Profile: ', result.data.data)
                this.dataakun = result.data.data
                this.akunemail = result.data.data.email
                this.datainvestor = result.data.data;
                this.loading = false
                if(result.data.data.profile_verified_at !== null)
                {
                    this.$router.push('/profile')
                }
            }).catch(() => {
                // console.log('Error Profile: ', err.response)
            })
        },
        NumbersOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
		onFileChange(e){
            var input = e.target;
            const isLt2M = input.files[0].size / 1024 / 1024 < 2;
            if (isLt2M) {
                if (input.value !== "") {
                    var reader = new FileReader();
                    reader.onload = (e) => {
                        this.preview = e.target.result;
                    }
                    this.image=input.files[0];
                    reader.readAsDataURL(input.files[0]);
                    this.imageName = e.target.files[0];
                }    
            } else{
                // console.log('File more than 2mb.')
				this.error.identity_file = 'File more than 2mb.'
            }
            // else{
            //     // this.img = URL.createObjectURL(event.target.files[0]);
            //     // this.datainvestor.identity_file = 
            // }
			// this.imageName = e.target.files[0];
			// this.datainvestor.identity_file = this.imageName
			// console.log("Identity File", this.datainvestor.identity_file)
		},
		onFileSelfieChange(e){
            var input2 = e.target;
            const isLt2M = input2.files[0].size / 1024 / 1024 < 2;
            if (isLt2M) {
                if (input2.value !== "") {
                    var reader = new FileReader();
                    reader.onload = (e) => {
                        this.viewSelfie = e.target.result;
                    }
                    this.imageSelfie=input2.files[0];
                    reader.readAsDataURL(input2.files[0]);
                    this.selfieImage = e.target.files[0];
                }
            } else{
                // console.log('File more than 2mb.')
				this.error.selfie_image = 'File more than 2mb.'
            }
			// this.nameFile = file
			// console.log(this.selfieImage)
		// $('#trade_report_data').css('background-image', 'url(' + Dataisi + ')');
		},
        onFileCompareChange(e){
            var fileInput = e.target;
            const isLt2M = fileInput.files[0].size / 1024 / 1024 < 2;
            if (isLt2M) {
                if (fileInput.files) {
                    var reader = new FileReader();
                    reader.onload = (e) => {
                        this.viewCompare = e.target.result;
                    }
                    this.imageCompare=fileInput.files[0];
                    reader.readAsDataURL(fileInput.files[0]);
                    this.compareImage = e.target.files[0];
                }
            } else{
                // console.log('File more than 2mb.')
				this.error.comparison_file = 'File more than 2mb.'
            }
			// this.nameFile = file
			// console.log(this.compareImage)
		// $('#trade_report_data').css('background-image', 'url(' + Dataisi + ')');
		},
		// sendUser(dataakun) {
		// 	this.datainvestor = dataakun;
		// 	console.log("Get Data Investor", this.datainvestor)
		// },
        countryChanged(country) {
            // console.log("countryChanged")
            this.phoneFirstTimeLoad++;
            let countryCode = country.dialCode;

            if (this.phoneFirstTimeLoad > 0) {
                const myPromise = new Promise((resolve) => {
                    resolve((this.phone = ""));
                });

                myPromise.then(() => {
                    if(this.datainvestor.phone){
                        // console.log('datapertama')
                        if (this.datainvestor.phone == '') {
                            this.datainvestor.phone = `+${countryCode}`
                        }
                    }else{
                        this.datainvestor.phone = `+${countryCode}`;
                    }
                
                });
            }
        },
        // countryChanged(country) {
        //     this.country = '+' + country.dialCode
        // },
        validatePhone(country) {
            // console.log("validatePhone")     
            this.phoneValid = country.valid;
        },
        validateFirstLetter() {
            // console.log("validateFirstLetter")
            if (this.datainvestor.phone[0] != "+") {
                this.phoneValid = false;
            }
            
        },
		editProfile(){
            this.submitted=true
			// console.log('Identity Photo: ', this.imageName)
			// console.log('Selfie Image: ', this.selfieImage)
			// if(this.akunemail == this.datainvestor){
				let data = new FormData()
				data.append('id', this.dataakun.id)
				data.append('first_name', this.datainvestor.first_name)
				data.append('last_name', this.datainvestor.last_name)
				// data.append('name', this.datainvestor.name)
				// data.append('username', this.datainvestor.username)
				// data.append('email', this.datainvestor.email)
				data.append('phone', this.datainvestor.phone)
				if(this.imageName == ""){
                    data.delete('identity_file')
                    // data.append('identity_file', this.datainvestor.identity_file)
                    // console.log('Identity Photo IF 1: ')
				} else if(this.imageName !== ""){
                    data.append('identity_file', this.imageName)
                    // data.append('identity_file', this.datainvestor.identity_file)
                    // console.log('Identity Photo IF 2: ')
					// data.append('identity_file', this.imageName)
				} else{
					// data.append('identity_file', this.imageName)
                    // console.log('Identity Photo Else: ')
                    data.append('identity_file', this.datainvestor.identity_file)
                }

				if(this.compareImage == ""){
                    data.delete('comparison_file')
                    // data.append('comparison_file', this.datainvestor.comparison_file)
                    // console.log('Compare File IF 1: ')
				} else if(this.compareImage !== ""){
                    // data.append('comparison_file', this.datainvestor.comparison_file)
					data.append('comparison_file', this.compareImage)
                    // console.log('Compare File IF 2: ')
                    // data.append('comparison_file', this.compareImage)
                }else{
                    // console.log('Compare File Else: ')
                    // data.append('comparison_file', this.compareImage)
                    data.append('comparison_file', this.datainvestor.comparison_file)
                }

				if(this.selfieImage == ""){
					data.delete('selfie_image')
					// data.append('selfie_image', this.selfieImage)
                    // data.append('selfie_image', this.datainvestor.selfie_image)
                    // console.log('Selfie File IF 1: ')
				} else if(this.selfieImage !== ""){
                    // data.append('selfie_image', this.datainvestor.selfie_image)
                    data.append('selfie_image', this.selfieImage)
                    // console.log('Selfie File IF 2: ')
                }else{
                    // console.log('Selfie File Else: ')
                    // data.append('selfie_image', this.selfieImage)
                    data.append('selfie_image', this.datainvestor.selfie_image)
                }

                // if(this.datainvestor.identity_number !== null || this.datainvestor.identity_number !== '')
                // {
                //     data.delete('identity_number')
                // } else{
                //     }
                data.append('identity_number', this.datainvestor.identity_number)
				data.append('identity_type', this.datainvestor.identity_type)
				// data.append('selfie_image', this.datainvestor.selfie_image)
				data.append('dob', this.datainvestor.dob)
				
                // if(this.datainvestor.country == '')
				// {
				// 	data.append('country', this.datainvestor.country)
				// } else{
				// 	data.append('country', this.datainvestor.country)
				// }
				
				// if(this.datainvestor.city == '')
				// {
				// 	data.append('city', this.datainvestor.city)
				// } else{
				// 	data.append('city', this.datainvestor.city)
				// }

				// if(this.datainvestor.address == '')
				// {
				// 	data.append('address', this.datainvestor.address)
				// } else{
				// 	data.append('address', this.datainvestor.address)
				// }
                // data.append('country', this.datainvestor.country)
				
				if(this.datainvestor.country == "" || this.datainvestor.country == null)
				{
					data.append('country', "")
				} else{
					data.append('country', this.datainvestor.country)
				}
				if(this.datainvestor.city == "" || this.datainvestor.city == null)
				{
					data.append('city', "")
				} else{
					data.append('city', this.datainvestor.city)
				}

				if(this.datainvestor.address == '' || this.datainvestor.address == null)
				{
					data.append('address', "")
				} else{
					data.append('address', this.datainvestor.address)
				}

                // console.log('Form Data: ', data)
                this.$validator.validate().then(isValid => {
                    if(isValid){
                        this.loading = true
						if(this.datainvestor.phone.length<6 || this.datainvestor.phone == '' || this.datainvestor.phone[0] != "+"){
							this.loading = false;
							this.validPhone = true;
						}
						else if(this.imageName == null){
							this.loading = false;
							this.validPhone = true;
						}else if(this.compareImage == null){
							this.loading = false;
							this.validPhone = true;
						}else if(this.selfieImage == null){
							this.loading = false;
							this.validPhone = true;
						}
						else{
                            axios.put(`investor/${this.dataakun.id}/`, data)
                            .then((response) => {
                                // console.log(response);
                                // if(response.data.data.status === 200) {
                                    this.loading = true
                                    this.validPhone = true;
									this.sukses = response.data
                                    setTimeout(() => {
                                        this.$router.push({ path: `/profile` })
                                    }, 2000)
                                    
                                    // window.location.reload()
                                    // return router.push({
                                        // name: 'Login'
                                    // })
                                // } else {
                                // 	this.loading = false
                                // 	// validation.value = response.data.response
                                // 	// console.log(validation);
                                // }
                            }).catch((error) => {
                                this.loading = false
                                this.message = error.data.data || error.response.data.data
                                // console.log(error.response)
                            })
                        }
                    }else{
						// this.submitted = false
						this.loading = false;
						this.validPhone = true;
					}
                })
			// }
		}
	}
}
</script>

<style scoped>
.capitalize{
    text-transform: capitalize;
}
.edit_profile img.img_identity{
    width: auto;
    height: 80px;
    margin-top: 20px;
}
.edit_profile img.img_identity2{
    width: auto;
    height: 80px;
    margin-top: 20px;
}
.edit_profile img.img_identity3{
    width: auto;
    height: 80px;
    margin-top: 20px;
}
.edit_profile .photo_upload input[type="file"] {
    display: none;
}
.edit_profile .photo_upload .custom-file-upload {
    border: 1px solid #ccc;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
    border-radius: 5px;
    margin-bottom: 40px;
    display: flex;
    /* width: 50%; */
    align-items: center;
    justify-content: center;
}

.edit_profile .form-group{
    margin-bottom: 5px;
}
.edit_profile .form-group label{
    font-size: 10pt;
    margin: 0;
}
.edit_profile input.form-control{
    padding: 15px;
}

.edit_profile .btn_outline_red{
    padding: 10px !important;
}

@media(max-width: 767.98px){
    .c-btn{
        order: 2;
    }
    .up-btn{
        order: 1;
    }
}
</style>